import React from 'react';
import logo from '../../assets/calcium-logo.svg';
import styles from './RootReturningPlaceholder.module.css';

/** Minimal chrome while Clerk hydrates — avoids flashing marketing landing for returning sessions. */
const RootReturningPlaceholder = () => (
	<div className={styles.shell} role='status' aria-live='polite'>
		<img src={logo} alt='' width={144} height={36} className={styles.logo} />
		<span className={styles.srOnly}>Opening Calcium…</span>
	</div>
);

export default RootReturningPlaceholder;
